import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * External dependencies
 */
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated';
import Icon from './Icon';
const animatedComponents = makeAnimated();
const { Option } = components;
const IconOption = (props) => (_jsx(Option, { ...props, children: _jsxs("span", { className: "flex items-center justify-between", children: [_jsx("span", { children: props.data.label }), _jsx("span", { className: "w-6 h-6", children: props.isSelected ?
                    _jsx("span", { className: "text-green", children: _jsx(Icon, { name: "circle-tick" }) }) : _jsx("span", { className: "text-grey-50", children: _jsx(Icon, { name: "circle" }) }) })] }) }));
const customStyles = {
    control: (provided, state) => ({
        display: 'flex',
        alignItems: 'center',
        borderBottom: state.isFocused ? '1px solid #96C255' : '1px solid #BBBBB7',
        color: '#000',
        height: '4.25rem',
        width: '100%'
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#96C255',
        padding: 0
    }),
    indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none'
    }),
    input: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0
    }),
    menu: (provided, state) => ({
        ...provided,
        border: 0,
        borderTop: '0.25rem solid #96C255',
        borderRadius: 0,
        margin: 0,
        padding: 0,
        zIndex: 9999
    }),
    menuList: (provided, state) => ({
        ...provided,
        borderLeft: '1px solid #E2E2DD',
        borderRight: '1px solid #E2E2DD',
        borderBottom: '1px solid #E2E2DD',
        borderRadius: 0,
        margin: 0,
        padding: '0.5rem 1.5rem'
    }),
    menuPortal: (provided, state) => ({
        ...provided,
        zIndex: 9999
    }),
    option: (provided, state) => {
        const lastOption = state.options[state.options.length - 1];
        return {
            ...provided,
            background: '#fff',
            borderBottom: lastOption.label === state.label ? 0 : '1px solid #E2E2DD',
            color: state.isSelected ? '#96C255' : '#777771',
            fontFamily: 'Poppins',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            padding: '1rem 0'
        };
    },
    placeholder: (provided, state) => ({
        ...provided,
        color: state.isFocused ? '#000' : '#777771',
        fontFamily: 'Poppins',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        margin: 0,
        padding: 0
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: '#000',
        fontFamily: 'Poppins',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        margin: 0,
        padding: 0
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        padding: 0
    })
};
const Dropdown = ({ options, placeholder, onChange, name }) => {
    return (_jsx("div", { children: _jsx(Select, { classNamePrefix: "react-select", styles: customStyles, options: options, name: name, placeholder: placeholder, onChange: onChange, isSearchable: false, components: { Option: IconOption } }) }));
};
export default Dropdown;
